import { getUserData } from "./AuthService";
import _ from "lodash";

// ================================================================================================
// APPS
// ================================================================================================
export const APP_REPORT = "reports";
export const APP_INVENTORY = "inventory";
export const APP_MAINTENANCE = "maintenance";

// =================================================================================================
// MODELS
// =================================================================================================
export const SHIPMENTREPORT = "shipmentreport";
export const OFFERLIST = "offerlist";
export const MAINTENANCERECORD = "maintenancerecord";

// =================================================================================================
//MAPPING_MODELS_IN_APPS
// =================================================================================================
export const MAPPING_MODELS_IN_APPS = {
  shipmentreport: APP_REPORT,
  inventory: APP_INVENTORY,
  offerlist: APP_INVENTORY,
  maintenancerecord: APP_MAINTENANCE,
};

// ==================================================================================================
// DEFAULT PERMISSIONS
// =================================================================================================
export const ADD = "add";
export const DELETE = "delete";
export const VIEW = "view";
export const UPDATE = "update";
export const CREATE = "create";

export const DEFAULT_PERMS = [ADD, DELETE, VIEW, UPDATE, CREATE];

export function get_codename(model, action) {
  return action + "_" + model;
}

// ==================================================================================================
// CUSTOM PERMISSIONS
// ==================================================================================================

// REPORTS - SHIPMENTREPORTS
export const CAN_LIST_R365_REPORTS = "can_list_r365_reports";

// INVENTORY - OFFERLIST
export const CAN_USE_VENDOR_OFFERS = "can_use_vendor_offers";

// MAINTENANCE - MAINTENANCERECORD
export const CAN_APPROVE_MAINTENANCE = "can_approve_maintenance";

// ==================================================================================================
// AUXILIARY FUNCTIONS ==============================================================================
// ==================================================================================================

export function hasPermission(model, perm_name) {
  // This function receive a model like SHIPMENTREPORT and a permission name like VIEW or CAN_MARK_ORDER_RECEIVED
  // The result is true if the user has the permisions perm_name asociated to the model, in otherwise the result is false.
  const user = getUserData();
  const codename = DEFAULT_PERMS.includes(perm_name) ? get_codename(model, perm_name) : perm_name;
  const app = MAPPING_MODELS_IN_APPS[model];
  return (
    user &&
    user.permissions &&
    app &&
    app in user.permissions &&
    model in user.permissions[app] &&
    user.permissions[app][model].findIndex((perm) => {
      return codename === perm;
    }) > -1
  );
}

export function chekAllPermissions(perms) {
  // This function receive a list of dicts like {model: SHIPMENTREPORT, perms: [VIEW, DELETE, CAN_MARK_ORDER_RECEIVED]}
  // The result is true if the user has ALL permisions in the list of perms, in otherwise the result is false
  let allowed = true;
  _.forEach(perms, function (model_perms) {
    const model_name = model_perms["model"];
    allowed = allowed && model_perms["perms"].every((perm) => hasPermission(model_name, perm));
  });
  return allowed;
}

export function checkAnyPermissions(perms) {
  // This function receive a list of dicts like {model: SHIPMENTREPORT, perms: [VIEW, DELETE, CAN_MARK_ORDER_RECEIVED]}
  // The result is true if the user has ANY permisions in the list of perms, in otherwise the result is false
  let allowed = false;
  _.forEach(perms, function (model_perms) {
    const model_name = model_perms["model"];
    allowed = allowed || model_perms["perms"].some((perm) => hasPermission(model_name, perm));
  });
  return allowed;
}
